<template>
  <div id="applicable_law">
    <h5 class="headline">{{ $t("contract.applicableLaw.headline") }}</h5>
    <p>
      {{ $t("contract.applicableLaw.paragraphOne") }}
    </p>
    <p>
      {{ $t("contract.applicableLaw.paragraphTwo") }}
    </p>
    <p>
      {{ $t("contract.applicableLaw.paragraphThree") }}
    </p>
    <p class="user-output">
      {{ $t("contract.applicableLaw.paragraphFour", { rules }) }}
    </p>
    <hr />
  </div>
</template>

<script>
export default {
  computed: {
    applicableLaw() {
      return this.$store.state.contract.applicableLaw;
    },
    rules() {
      if (this.applicableLaw.isCourt == null) {
        return this.$t("contract.applicableLaw.placeholder.rules");
      }
      return this.applicableLaw.isCourt
        ? this.$t("contract.applicableLaw.rulesValues.retten")
        : this.$t("contract.applicableLaw.rulesValues.voldgift");
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/apps/hemmelig/components/contract/ApplicableLaw.vue